import newRequest, { buildBaseURL } from "./newRuequest";

const getPrefix = () => "";
const getVersion = () => "v6";

export const publishCustomPage = async (id, token) => {
  const url =
    buildBaseURL(getVersion(), getPrefix()) + `merchant/custom-pages/${id}/publish`;
  const result = await newRequest.post(url, {}, token);
  return result?.data;
};

export const duplicateCustomPage = async (id, token) => {
  const url =
    buildBaseURL(getVersion(), getPrefix()) + `merchant/custom-pages/${id}/duplicate`;
  const result = await newRequest.post(url, {}, token);
  return result?.data;
};


